import React, {useState, useCallback, useEffect, useContext} from 'react';
// import axios from 'axios';
import styled from 'styled-components';
import {OverlayContext} from '../../../contexts/OverlayContext';

import {GHOSTWHITE, SILVERTREE, BORDER, OzCard, CHETWODEBLUE} from "@ozwol/webui";

const Wrapper = styled.div`
  position: fixed;
  bottom: 15px;
  right: 15px;
  width: 550px;

  text-align: left;
  z-index: 999;

  & > *{
		padding: 0px;
    box-shadow: #c1cce890 0px 3px 2px;
		border: 1px solid ${CHETWODEBLUE}99;
  }
	
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  background: ${GHOSTWHITE};
	width: 100%;
	height: 100%;
  padding: 10px 14px;
	box-shadow: #c1cce890 0px 3px 10px;
	font-weight: 700;
`;
const Content = styled.div`
  height: 200px;
  overflow-x: hidden;
  overflow-y: scroll;
  width: 100%;
`;
// const Loader = styled.div`
//   float: right;
// `;
const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 14px;
  gap: 8px;
	border-top: 1px solid ${BORDER};
`;
const Icon = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 5px;
  margin-bottom: -1px;
  flex-grow: 0;
  flex-shrink: 0;

  & span{
    display: block;
  }

	${props => props.spinner ? 
		`
  		margin-right: 10px;
			color: ${SILVERTREE};

			@keyframes spin {
				from {transform:rotate(0deg);}
				to {transform:rotate(360deg);}
			}
			
			animation: spin 0.40s linear infinite;
			
		`
	: null }

`;
const Name = styled.div`
  width: 60%;
  font-size: 11px;
	text-overflow: ellipsis;
	overflow: hidden;
`;
const Bar = styled.div`
  position: relative;
  border: 1px solid ${BORDER}; 
  height: 5px;
  flex-grow: 1;
  flex-shrink: 1;
  background-color: #ffffff;


  &::after{
    content: "";
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    width: ${props => props.value}%;
    height: 100%;
    background-color: ${SILVERTREE};
    transition: width 0.25s ease-out;
  }
`;


const UploadPolling = () => {
  const {removeOverlay} = useContext(OverlayContext);

  const [count, setCount] = useState(0);
  const [text, setText] = useState("");


	const check = useCallback(() => {
    let status = localStorage.getItem("ozwolConsoleLoading"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)));
    if(!status){
      status = {};
    }else{
      status = JSON.parse(status);
    }
    // console.log(status);

    let tempStatus = JSON.parse(JSON.stringify(status));
    Object.keys(tempStatus).forEach(key => {
      if(tempStatus[key]["lastUpdate"] + (10*60*1000) < new Date()){ //30min x 60sec x 1000 millisec
        // console.log(tempStatus[key]["lastUpdate"]);
        delete tempStatus[key];
      }else{
      }
    });
    localStorage.setItem("ozwolConsoleLoading"+(process.env.REACT_APP_ENV.charAt(0).toUpperCase()+process.env.REACT_APP_ENV.substr(1)), JSON.stringify(tempStatus));

    if(status && Object.keys(status).length > 0){
      setText(<>
        {Object.keys(status).sort((keyA, keyB) => status[keyB]["percent"] - status[keyA]["percent"]).map((key) => <Row key={key}><Icon><span className="material-symbols-outlined">image</span></Icon><Name>{key.substring(key.lastIndexOf('/') + 1)}</Name><Bar value={status[key]["percent"]} /></Row>)}
      </>);
      setCount(Object.keys(status).length);
      setTimeout(() => {check()}, 250)
    }else{
      removeOverlay("uploadPolling");
    }

    
  }, [removeOverlay]);  
 

  useEffect(() => {
		check();
  }, [check]);

  return (
    <Wrapper>
      <OzCard
        variant={"default"}
			>
				<Header>
					<Icon spinner><span className="material-symbols-outlined">progress_activity</span></Icon>
					{count + " files remaining..."}
				</Header>
        <Content>
          {text}
        </Content>
      </OzCard>
    </Wrapper>
  )
}

export default UploadPolling;
